import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="filter" {...props} />;
}

export const meta = {
  id: 'CMSCampaignsDetails',
  title: 'CMSCampaignsDetails',
  category: 'CMS',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manages the campaigns for the CMS within the current tenant`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 670,
    height: 510
  }
};
